import { Observable } from 'rxjs';
import { SchedulerItemOnMachineCRUD } from '../../../api/backend/dto/scheduler-item-on-machine.dto';
import { SchedulerItemOnMachine } from '../models/item-on-machine';
import { Injectable } from '@angular/core';

type AddBody = SchedulerItemOnMachineCRUD['add'];
type UpdateBody = SchedulerItemOnMachineCRUD['update'];

@Injectable()
export abstract class SchedulerDragDropApiAbstract {
  abstract addItem(body: AddBody): Observable<SchedulerItemOnMachine>;

  abstract updateItem(body: UpdateBody): Observable<SchedulerItemOnMachine>;

  abstract removeItem(itemId: number, machineId: number): Observable<any>;

  abstract updateRank(itemId: number, rank: string): Observable<any>;
}
